_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[46],{

/***/ "1/IK":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "1ccW":
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ "1vB5":
/***/ (function(module, exports) {

module.exports = "/_next/static/images/rich-content-0d03c963cd881715e85477f0a2ee2e57.png";

/***/ }),

/***/ "5fIB":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("7eYB");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),

/***/ "5fQi":
/***/ (function(module, exports) {

module.exports = "/_next/static/images/customizing-efa6a0151dde189926ca8b91ca199deb.png";

/***/ }),

/***/ "98FW":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ "Aiso":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("dQHF")


/***/ }),

/***/ "Fl18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/commonjs/index.js
var commonjs = __webpack_require__("yLev");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__("7vrA");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__("zLVn");

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("17x9");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Dropdown.js + 6 modules
var Dropdown = __webpack_require__("97+O");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/DropdownToggle.js
var DropdownToggle = __webpack_require__("4OCD");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/DropdownMenu.js + 1 modules
var DropdownMenu = __webpack_require__("rSmC");

// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/DropdownButton.js







var propTypes = {
  /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: prop_types_default.a.any,

  /** An `href` passed to the Toggle component */
  href: prop_types_default.a.string,

  /** An `onClick` handler passed to the Toggle component */
  onClick: prop_types_default.a.func,

  /** The content of the non-toggle Button.  */
  title: prop_types_default.a.node.isRequired,

  /** Disables both Buttons  */
  disabled: prop_types_default.a.bool,

  /**
   * Aligns the dropdown menu responsively.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   *
   * @type {"left"|"right"|{ sm: "left"|"right" }|{ md: "left"|"right" }|{ lg: "left"|"right" }|{ xl: "left"|"right"} }
   */
  menuAlign: DropdownMenu["a" /* alignPropType */],

  /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */
  menuRole: prop_types_default.a.string,

  /** Whether to render the dropdown menu in the DOM before the first time it is shown */
  renderMenuOnMount: prop_types_default.a.bool,

  /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   */
  rootCloseEvent: prop_types_default.a.string,

  /** @ignore */
  bsPrefix: prop_types_default.a.string,

  /** @ignore */
  variant: prop_types_default.a.string,

  /** @ignore */
  size: prop_types_default.a.string
};
/**
 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
 * are passed directly to the default `Dropdown.Menu`.
 *
 * _All unknown props are passed through to the `Dropdown` component._ Only
 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
 * along with menu related props are passed to the `Dropdown.Menu`
 */

var DropdownButton = react_default.a.forwardRef(function (_ref, ref) {
  var title = _ref.title,
      children = _ref.children,
      bsPrefix = _ref.bsPrefix,
      rootCloseEvent = _ref.rootCloseEvent,
      variant = _ref.variant,
      size = _ref.size,
      menuAlign = _ref.menuAlign,
      menuRole = _ref.menuRole,
      renderMenuOnMount = _ref.renderMenuOnMount,
      disabled = _ref.disabled,
      href = _ref.href,
      id = _ref.id,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["title", "children", "bsPrefix", "rootCloseEvent", "variant", "size", "menuAlign", "menuRole", "renderMenuOnMount", "disabled", "href", "id"]);

  return /*#__PURE__*/react_default.a.createElement(Dropdown["a" /* default */], Object(esm_extends["a" /* default */])({
    ref: ref
  }, props), /*#__PURE__*/react_default.a.createElement(DropdownToggle["a" /* default */], {
    id: id,
    href: href,
    size: size,
    variant: variant,
    disabled: disabled,
    childBsPrefix: bsPrefix
  }, title), /*#__PURE__*/react_default.a.createElement(DropdownMenu["b" /* default */], {
    align: menuAlign,
    role: menuRole,
    renderOnMount: renderMenuOnMount,
    rootCloseEvent: rootCloseEvent
  }, children));
});
DropdownButton.displayName = 'DropdownButton';
DropdownButton.propTypes = propTypes;
/* harmony default export */ var esm_DropdownButton = (DropdownButton);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__("IP2g");

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var fontawesome_svg_core_index_es = __webpack_require__("7O5W");

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.es.js
var pro_solid_svg_icons_index_es = __webpack_require__("4Bjl");

// EXTERNAL MODULE: ./share/language.js
var share_language = __webpack_require__("1kOT");

// EXTERNAL MODULE: ./share/routes.js
var routes = __webpack_require__("85xM");

// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__("k7Sn");

// EXTERNAL MODULE: ./components/Footer/footer.scss
var footer = __webpack_require__("mLyT");

// CONCATENATED MODULE: ./components/Footer/index.js













fontawesome_svg_core_index_es["b" /* library */].add(pro_solid_svg_icons_index_es["g" /* faHeart */]);

var Footer_LangItem = function LangItem(_ref) {
  var locale = _ref.locale,
      t = _ref.t;
  return /*#__PURE__*/Object(jsx_runtime["jsx"])("li", {
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
      className: "set-language",
      "data-lang": locale,
      href: "?locale=".concat(locale),
      children: t(locale)
    })
  });
};

function Footer(_ref2) {
  var t = _ref2.t;

  var _useContext = Object(react["useContext"])(commonjs["I18nContext"]),
      language = _useContext.i18n.language;

  return /*#__PURE__*/Object(jsx_runtime["jsx"])("footer", {
    children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(Container["a" /* default */], {
      children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "footer-wrapper",
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("p", {
          children: ["Designed with \xA0", /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
            icon: "heart"
          }), "\xA0 in Taiwan"]
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
          className: "copyright",
          children: "\xA9 2020 CakeResume"
        })]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "footer-wrapper",
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          className: "footer-link-wrapper",
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
            href: routes["j" /* PRIVACY_POLICY_ROUTE_PATH */],
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              className: "footer-link",
              target: "_blank",
              children: t('privacy')
            })
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
            href: routes["l" /* TERMS_OF_SERVICE_ROUTE_PATH */],
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              className: "footer-link",
              target: "_blank",
              children: t('termsOfService')
            })
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          className: "footer-language-selector",
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            className: "language",
            children: t('language')
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(esm_DropdownButton, {
            drop: "up",
            alignRight: true,
            variant: "default",
            title: t(language),
            className: "btn-group",
            id: "language-dropdown",
            children: share_language["a" /* LANGUAGES */].map(function (l) {
              return /*#__PURE__*/Object(jsx_runtime["jsx"])(Footer_LangItem, {
                locale: l,
                t: t
              }, l);
            })
          })]
        })]
      })]
    })
  });
}

/* harmony default export */ var components_Footer = __webpack_exports__["a"] = (Object(i18n["withTranslation"])('common')(Footer));

/***/ }),

/***/ "GwEz":
/***/ (function(module, exports) {

module.exports = "/_next/static/images/templates-7c6fa437104bd1b0efb8f07fb30ae8fc.png";

/***/ }),

/***/ "HaE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "LbSa":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
var React = __webpack_require__("q1tI");
var SpriteSymbol = __webpack_require__("4BeY");
var sprite = __webpack_require__("IaFt");

var symbol = new SpriteSymbol({
  "id": "slick_logo-b227c1bd--sprite",
  "use": "slick_logo-b227c1bd--sprite-usage",
  "viewBox": "0 0 82 34",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 82 34\" id=\"slick_logo-b227c1bd--sprite\"><g clip-path=\"url(#slick_logo-b227c1bd--sprite_clip0)\" fill=\"#434F4A\"><path d=\"M18.867 7.438l-3.732 2.217c-.697-1.214-1.362-2.006-1.994-2.376-.658-.422-1.507-.634-2.547-.634-1.277 0-2.337.364-3.18 1.09-.842.712-1.263 1.61-1.263 2.693 0 1.491 1.106 2.693 3.317 3.604l3.041 1.247c2.475 1.003 4.285 2.231 5.43 3.683 1.145 1.44 1.718 3.208 1.718 5.307 0 2.812-.935 5.136-2.804 6.97-1.882 1.849-4.219 2.773-7.01 2.773-2.645 0-4.83-.786-6.555-2.357C1.59 30.085.531 27.873.11 25.022l4.66-1.03c.21 1.795.58 3.036 1.106 3.723.948 1.32 2.33 1.98 4.146 1.98 1.435 0 2.626-.482 3.574-1.446.948-.963 1.422-2.184 1.422-3.663 0-.594-.086-1.135-.257-1.624a3.813 3.813 0 00-.77-1.366c-.342-.422-.79-.812-1.343-1.168-.553-.37-1.21-.72-1.974-1.05L7.73 18.15c-4.173-1.768-6.26-4.356-6.26-7.762 0-2.297.876-4.218 2.627-5.762 1.75-1.558 3.929-2.337 6.535-2.337 3.515 0 6.26 1.716 8.234 5.149zM28.799.012v33.445h-4.443V.012h4.443zM38.868 14.17v19.287h-4.442V14.17h4.442zm-5.114-8.02c0-.779.283-1.452.85-2.02a2.77 2.77 0 012.033-.851c.803 0 1.487.284 2.053.852.567.554.85 1.234.85 2.04a2.81 2.81 0 01-.85 2.059c-.552.567-1.23.851-2.033.851a2.793 2.793 0 01-2.054-.851c-.566-.568-.849-1.261-.849-2.08zm25.708 8.852v5.92c-1.013-1.24-1.922-2.092-2.725-2.554-.79-.475-1.717-.713-2.784-.713-1.671 0-3.06.588-4.166 1.763-1.105 1.175-1.658 2.646-1.658 4.416 0 1.808.533 3.293 1.6 4.455 1.078 1.162 2.454 1.742 4.126 1.742 1.066 0 2.007-.23 2.823-.692.79-.45 1.718-1.32 2.784-2.614v5.88c-1.803.938-3.607 1.407-5.41 1.407-2.975 0-5.463-.964-7.463-2.891-2.001-1.941-3.002-4.35-3.002-7.228s1.014-5.307 3.041-7.287c2.027-1.98 4.515-2.97 7.464-2.97 1.895 0 3.685.455 5.37 1.366zM69.275.012v20.396l6.26-6.238h5.962l-8.352 8.1 8.965 11.187h-5.766l-6.358-8.138-.71.713v7.425h-4.443V.012h4.442z\" /></g><defs><clipPath id=\"slick_logo-b227c1bd--sprite_clip0\"><path fill=\"#fff\" d=\"M0 0h82v34H0z\" /></clipPath></defs></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;


/***/ }),

/***/ "Nrzz":
/***/ (function(module, exports) {

module.exports = "/_next/static/images/preview-22c0e27a76c0026fab531f3f8fe97a36.png";

/***/ }),

/***/ "ODaL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var logger = {
  error: function error(errorCode) {
    for (var _len = arguments.length, text = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      text[_key - 1] = arguments[_key];
    }

    if (!console) {
      return;
    }

    if (text && text.length <= 1) {
      text = text[0] || '';
    }

    console.error("[next-auth][error][".concat(errorCode.toLowerCase(), "]"), text, "\nhttps://next-auth.js.org/errors#".concat(errorCode.toLowerCase()));
  },
  warn: function warn(warnCode) {
    for (var _len2 = arguments.length, text = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      text[_key2 - 1] = arguments[_key2];
    }

    if (!console) {
      return;
    }

    if (text && text.length <= 1) {
      text = text[0] || '';
    }

    console.warn("[next-auth][warn][".concat(warnCode.toLowerCase(), "]"), text, "\nhttps://next-auth.js.org/warning#".concat(warnCode.toLowerCase()));
  },
  debug: function debug(debugCode) {
    for (var _len3 = arguments.length, text = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      text[_key3 - 1] = arguments[_key3];
    }

    if (!console) {
      return;
    }

    if (text && text.length <= 1) {
      text = text[0] || '';
    }

    if (process && process.env && process.env._NEXTAUTH_DEBUG) {
      console.log("[next-auth][debug][".concat(debugCode.toLowerCase(), "]"), text);
    }
  }
};
var _default = logger;
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("8oxB")))

/***/ }),

/***/ "RNiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__("Aiso");
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./utils/auth.js


var auth_validateIsLogin = function validateIsLogin(session) {
  return !!(session && moment_default()(session.expires).valueOf() > moment_default()().valueOf());
};


// EXTERNAL MODULE: ./node_modules/next-auth/client.js
var client = __webpack_require__("nGE6");

// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__("IP2g");

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var fontawesome_svg_core_index_es = __webpack_require__("7O5W");

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-light-svg-icons/index.es.js
var pro_light_svg_icons_index_es = __webpack_require__("WE53");

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.es.js
var pro_regular_svg_icons_index_es = __webpack_require__("uB96");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__("7vrA");

// EXTERNAL MODULE: ./share/routes.js
var routes = __webpack_require__("85xM");

// EXTERNAL MODULE: ./public/images/Landing/slick_logo.svg?sprite
var slick_logosprite = __webpack_require__("LbSa");
var slick_logosprite_default = /*#__PURE__*/__webpack_require__.n(slick_logosprite);

// EXTERNAL MODULE: ./public/images/Landing/editor.png
var editor = __webpack_require__("v8fv");
var editor_default = /*#__PURE__*/__webpack_require__.n(editor);

// CONCATENATED MODULE: ./public/images/Landing/dragndrop.png
/* harmony default export */ var dragndrop = ("data:image/png;base64,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");
// EXTERNAL MODULE: ./public/images/Landing/templates.png
var templates = __webpack_require__("GwEz");
var templates_default = /*#__PURE__*/__webpack_require__.n(templates);

// EXTERNAL MODULE: ./public/images/Landing/layout.png
var layout = __webpack_require__("XZZD");
var layout_default = /*#__PURE__*/__webpack_require__.n(layout);

// EXTERNAL MODULE: ./public/images/Landing/customizing.png
var customizing = __webpack_require__("5fQi");
var customizing_default = /*#__PURE__*/__webpack_require__.n(customizing);

// EXTERNAL MODULE: ./public/images/Landing/dot-bg.png
var dot_bg = __webpack_require__("rCWS");
var dot_bg_default = /*#__PURE__*/__webpack_require__.n(dot_bg);

// EXTERNAL MODULE: ./public/images/Landing/rich-content.png
var rich_content = __webpack_require__("1vB5");
var rich_content_default = /*#__PURE__*/__webpack_require__.n(rich_content);

// EXTERNAL MODULE: ./public/images/Landing/preview.png
var preview = __webpack_require__("Nrzz");
var preview_default = /*#__PURE__*/__webpack_require__.n(preview);

// EXTERNAL MODULE: ./components/Footer/index.js + 1 modules
var Footer = __webpack_require__("Fl18");

// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__("k7Sn");

// EXTERNAL MODULE: ./pages/landing.scss
var landing = __webpack_require__("PZVo");

// CONCATENATED MODULE: ./pages/index.js





























fontawesome_svg_core_index_es["b" /* library */].add(pro_regular_svg_icons_index_es["o" /* faFileDownload */], pro_regular_svg_icons_index_es["y" /* faShareAlt */], pro_light_svg_icons_index_es["z" /* faPrint */], pro_light_svg_icons_index_es["h" /* faDesktop */], pro_light_svg_icons_index_es["w" /* faMobile */]);

function Landing(_ref) {
  var t = _ref.t,
      isLogin = _ref.isLogin;
  var router = Object(next_router["useRouter"])();
  Object(react["useEffect"])(function () {
    if (isLogin) {
      router.push(routes["g" /* HOME_ROUTE_PATH */]);
    }
  }, []);
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(jsx_runtime["Fragment"], {
    children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
      className: "page_landing",
      children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "head-section",
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
          className: "slick-title-wrapper",
          children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(Container["a" /* default */], {
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
              className: "slick-title",
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(slick_logosprite_default.a, {
                width: "82",
                height: "34"
              })
            }), !isLogin && /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
              children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
                href: routes["i" /* LOGIN_ROUTE_PATH */],
                children: "Log in"
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
                href: routes["k" /* SIGN_UP_ROUTE_PATH */],
                children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
                  className: "btn btn-primary sign-up-btn",
                  children: "Sign up"
                })
              })]
            })]
          })
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Container["a" /* default */], {
          children: /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
            className: "content-wrapper",
            children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
              className: "content",
              children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
                children: t('classyEditor')
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])("h4", {
                children: t('classyEditorDesc')
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
                href: routes["k" /* SIGN_UP_ROUTE_PATH */],
                children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
                  className: "btn btn-primary",
                  children: "Try Now"
                })
              })]
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
              className: "img-container",
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
                src: editor_default.a,
                priority: true,
                loading: "eager",
                alt: "slick editor",
                width: 900,
                height: 555
              })
            })]
          })
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
          className: "bottom-line"
        })]
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        className: "templates-section",
        children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(Container["a" /* default */], {
          children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
            className: "content",
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
              children: t('speedyFormatting')
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
              className: "img-container",
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
                src: dragndrop,
                loading: "eager",
                alt: "slick editor",
                width: 91,
                height: 61
              })
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
              children: t('speedyFormattingDesc')
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
              href: routes["k" /* SIGN_UP_ROUTE_PATH */],
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
                className: "btn btn-default",
                children: "Try Now"
              })
            })]
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
            src: templates_default.a,
            priority: true,
            loading: "eager",
            alt: "slick editor",
            width: 750,
            height: 620
          })]
        })
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        className: "graceful-design",
        children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(Container["a" /* default */], {
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
            src: layout_default.a,
            loading: "eager",
            alt: "slick editor",
            width: 651,
            height: 566
          }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
            className: "content",
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
              children: t('elegantDesign')
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
              children: t('elegantDesignDesc')
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
              href: routes["k" /* SIGN_UP_ROUTE_PATH */],
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
                className: "btn btn-default",
                children: "Try Now"
              })
            })]
          })]
        })
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        className: "customizing-section",
        children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(Container["a" /* default */], {
          children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
            className: "content",
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
              children: t('highlyCustomizable')
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
              children: t('highlyCustomizableDesc')
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
              href: routes["k" /* SIGN_UP_ROUTE_PATH */],
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
                className: "btn btn-default",
                children: "Try Now"
              })
            })]
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
            src: customizing_default.a,
            loading: "eager",
            alt: "slick editor",
            width: 889,
            height: 616
          })]
        })
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        style: {
          backgroundImage: "url(".concat(dot_bg_default.a, ")")
        },
        className: "rich-content",
        children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(Container["a" /* default */], {
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
            src: rich_content_default.a,
            loading: "eager",
            alt: "slick editor",
            width: 686,
            height: 652
          }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
            className: "content",
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
              children: t('richElements')
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])("h4", {
              children: t('richElementsDesc')
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
              href: routes["k" /* SIGN_UP_ROUTE_PATH */],
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
                className: "btn btn-default",
                children: "Try Now"
              })
            })]
          })]
        })
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        className: "download-section",
        children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(Container["a" /* default */], {
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
            children: t('downloadOrShare')
          }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
            className: "way-blocks",
            children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
              className: "way-block",
              children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
                className: "icon",
                children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                  icon: ['far', 'file-download']
                })
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])("h3", {
                children: t('downloadPDF')
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])("h4", {
                children: t('downloadPDFSubTitle')
              })]
            }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
              className: "way-block",
              children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
                className: "icon",
                children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                  icon: ['far', 'share-alt']
                })
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])("h3", {
                children: t('shareOnline')
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])("h4", {
                children: t('shareOnlineSubTitle')
              }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
                dangerouslySetInnerHTML: {
                  __html: t('shareOnlineDesc').replace(/\r\n/g, '<br />')
                }
              })]
            })]
          })]
        })
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        className: "preview-section",
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Container["a" /* default */], {
          children: /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
            className: "preview-blocks-wrapper",
            children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
              className: "preview-blocks",
              children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
                className: "preview-block",
                children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
                  className: "icon",
                  children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                    icon: ['fal', 'print']
                  })
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("h4", {
                  children: "Print"
                })]
              }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
                className: "preview-block",
                children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
                  className: "icon",
                  children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                    icon: ['fal', 'desktop']
                  })
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("h4", {
                  children: "Desktop"
                })]
              }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
                className: "preview-block",
                children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
                  className: "icon",
                  children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                    icon: ['fal', 'mobile']
                  })
                }), /*#__PURE__*/Object(jsx_runtime["jsx"])("h4", {
                  children: "Mobile"
                })]
              })]
            }), /*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
              src: preview_default.a,
              loading: "eager",
              alt: "slick editor",
              width: 1025,
              height: 762
            })]
          })
        })
      })]
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Footer["a" /* default */], {})]
  });
}

Landing.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(context) {
    var session, isLogin;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Object(client["getSession"])(context);

          case 2:
            session = _context.sent;
            isLogin = auth_validateIsLogin(session);
            return _context.abrupt("return", {
              namespacesRequired: ['landing'],
              isLogin: isLogin
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ var pages = __webpack_exports__["default"] = (Object(i18n["withTranslation"])('landing')(Landing));

/***/ }),

/***/ "UWYU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
exports.__esModule=true;exports.imageConfigDefault=exports.VALID_LOADERS=void 0;const VALID_LOADERS=['default','imgix','cloudinary','akamai'];exports.VALID_LOADERS=VALID_LOADERS;const imageConfigDefault={deviceSizes:[640,750,828,1080,1200,1920,2048,3840],imageSizes:[16,32,48,64,96,128,256,384],path:'/_next/image',loader:'default',domains:[]};exports.imageConfigDefault=imageConfigDefault;
//# sourceMappingURL=image-config.js.map

/***/ }),

/***/ "XJ4Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = __webpack_require__("q1tI");

var _logger = _interopRequireDefault(__webpack_require__("ODaL"));

var _parseUrl = _interopRequireDefault(__webpack_require__("vFaK"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var __NEXTAUTH = {
  baseUrl: (0, _parseUrl.default)(process.env.NEXTAUTH_URL || process.env.VERCEL_URL).baseUrl,
  basePath: (0, _parseUrl.default)(process.env.NEXTAUTH_URL).basePath,
  keepAlive: 0,
  clientMaxAge: 0,
  _clientLastSync: 0,
  _clientSyncTimer: null,
  _eventListenersAdded: false,
  _clientSession: undefined,
  _clientId: Math.random().toString(36).substring(2) + Date.now().toString(36),
  _getSession: () => {}
};

if (typeof window !== 'undefined') {
  if (__NEXTAUTH._eventListenersAdded === false) {
    __NEXTAUTH._eventListenersAdded = true;
    window.addEventListener('storage', function () {
      var _ref = _asyncToGenerator(function* (event) {
        if (event.key === 'nextauth.message') {
          var message = JSON.parse(event.newValue);

          if (message.event && message.event === 'session' && message.data) {
            if (__NEXTAUTH._clientId === message.clientId) {
              return;
            }

            yield __NEXTAUTH._getSession({
              event: 'storage'
            });
          }
        }
      });

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    window.addEventListener('focus', function () {
      var _ref2 = _asyncToGenerator(function* (event) {
        return __NEXTAUTH._getSession({
          event: 'focus'
        });
      });

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    window.addEventListener('blur', function () {
      var _ref3 = _asyncToGenerator(function* (event) {
        return __NEXTAUTH._getSession({
          event: 'blur'
        });
      });

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
  }
}

var setOptions = function setOptions() {
  var {
    baseUrl,
    basePath,
    clientMaxAge,
    keepAlive
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (baseUrl) {
    __NEXTAUTH.baseUrl = baseUrl;
  }

  if (basePath) {
    __NEXTAUTH.basePath = basePath;
  }

  if (clientMaxAge) {
    __NEXTAUTH.clientMaxAge = clientMaxAge;
  }

  if (keepAlive) {
    __NEXTAUTH.keepAlive = keepAlive;

    if (typeof window !== 'undefined' && keepAlive > 0) {
      if (__NEXTAUTH._clientSyncTimer !== null) {
        clearTimeout(__NEXTAUTH._clientSyncTimer);
      }

      __NEXTAUTH._clientSyncTimer = setTimeout(_asyncToGenerator(function* () {
        if (__NEXTAUTH._clientSession) {
          yield __NEXTAUTH._getSession({
            event: 'timer'
          });
        }
      }), keepAlive * 1000);
    }
  }
};

var getSession = function () {
  var _ref5 = _asyncToGenerator(function* () {
    var {
      req,
      ctx,
      triggerEvent = true
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!req && ctx && ctx.req) {
      req = ctx.req;
    }

    var baseUrl = _apiBaseUrl();

    var fetchOptions = req ? {
      headers: {
        cookie: req.headers.cookie
      }
    } : {};
    var session = yield _fetchData("".concat(baseUrl, "/session"), fetchOptions);

    if (triggerEvent) {
      _sendMessage({
        event: 'session',
        data: {
          trigger: 'getSession'
        }
      });
    }

    return session;
  });

  return function getSession() {
    return _ref5.apply(this, arguments);
  };
}();

var getCsrfToken = function () {
  var _ref6 = _asyncToGenerator(function* () {
    var {
      req,
      ctx
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!req && ctx && ctx.req) {
      req = ctx.req;
    }

    var baseUrl = _apiBaseUrl();

    var fetchOptions = req ? {
      headers: {
        cookie: req.headers.cookie
      }
    } : {};
    var data = yield _fetchData("".concat(baseUrl, "/csrf"), fetchOptions);
    return data && data.csrfToken ? data.csrfToken : null;
  });

  return function getCsrfToken() {
    return _ref6.apply(this, arguments);
  };
}();

var getProviders = function () {
  var _ref7 = _asyncToGenerator(function* () {
    var baseUrl = _apiBaseUrl();

    return _fetchData("".concat(baseUrl, "/providers"));
  });

  return function getProviders() {
    return _ref7.apply(this, arguments);
  };
}();

var SessionContext = (0, _react.createContext)();

var useSession = session => {
  var value = (0, _react.useContext)(SessionContext);

  if (value === undefined) {
    return _useSessionHook(session);
  }

  return value;
};

var _useSessionHook = session => {
  var [data, setData] = (0, _react.useState)(session);
  var [loading, setLoading] = (0, _react.useState)(true);

  var _getSession = function () {
    var _ref8 = _asyncToGenerator(function* () {
      var {
        event = null
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      try {
        var triggredByEvent = event !== null;
        var triggeredByStorageEvent = !!(event && event === 'storage');
        var clientMaxAge = __NEXTAUTH.clientMaxAge;
        var clientLastSync = parseInt(__NEXTAUTH._clientLastSync);
        var currentTime = Math.floor(new Date().getTime() / 1000);
        var clientSession = __NEXTAUTH._clientSession;

        if (triggeredByStorageEvent === false && clientSession !== undefined) {
          if (clientMaxAge === 0 && triggredByEvent !== true) {
            return;
          } else if (clientMaxAge > 0 && clientSession === null) {
            return;
          } else if (clientMaxAge > 0 && currentTime < clientLastSync + clientMaxAge) {
            return;
          }
        }

        if (clientSession === undefined) {
          __NEXTAUTH._clientSession = null;
        }

        __NEXTAUTH._clientLastSync = Math.floor(new Date().getTime() / 1000);
        var triggerEvent = triggeredByStorageEvent === false;
        var newClientSessionData = yield getSession({
          triggerEvent
        });
        __NEXTAUTH._clientSession = newClientSessionData;
        setData(newClientSessionData);
        setLoading(false);
      } catch (error) {
        _logger.default.error('CLIENT_USE_SESSION_ERROR', error);
      }
    });

    return function _getSession() {
      return _ref8.apply(this, arguments);
    };
  }();

  __NEXTAUTH._getSession = _getSession;
  (0, _react.useEffect)(() => {
    _getSession();
  });
  return [data, loading];
};

var signIn = function () {
  var _ref9 = _asyncToGenerator(function* (provider) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var baseUrl = _apiBaseUrl();

    var callbackUrl = args && args.callbackUrl ? args.callbackUrl : window.location;
    var providers = yield getProviders();

    if (!provider || !providers[provider]) {
      window.location = "".concat(baseUrl, "/signin?callbackUrl=").concat(encodeURIComponent(callbackUrl));
    } else {
      var signInUrl = providers[provider].type === 'credentials' ? "".concat(baseUrl, "/callback/").concat(provider) : "".concat(baseUrl, "/signin/").concat(provider);
      var fetchOptions = {
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: _encodedForm(_objectSpread(_objectSpread({}, args), {}, {
          csrfToken: yield getCsrfToken(),
          callbackUrl: callbackUrl,
          json: true
        }))
      };
      var res = yield fetch(signInUrl, fetchOptions);
      var data = yield res.json();
      window.location = data.url ? data.url : callbackUrl;
    }
  });

  return function signIn(_x4) {
    return _ref9.apply(this, arguments);
  };
}();

var signOut = function () {
  var _ref10 = _asyncToGenerator(function* () {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callbackUrl = args && args.callbackUrl ? args.callbackUrl : window.location;

    var baseUrl = _apiBaseUrl();

    var fetchOptions = {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: _encodedForm({
        csrfToken: yield getCsrfToken(),
        callbackUrl: callbackUrl,
        json: true
      })
    };
    var res = yield fetch("".concat(baseUrl, "/signout"), fetchOptions);
    var data = yield res.json();

    _sendMessage({
      event: 'session',
      data: {
        trigger: 'signout'
      }
    });

    window.location = data.url ? data.url : callbackUrl;
  });

  return function signOut() {
    return _ref10.apply(this, arguments);
  };
}();

var Provider = (_ref11) => {
  var {
    children,
    session,
    options
  } = _ref11;
  setOptions(options);
  return (0, _react.createElement)(SessionContext.Provider, {
    value: useSession(session)
  }, children);
};

var _fetchData = function () {
  var _ref12 = _asyncToGenerator(function* (url) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    try {
      var res = yield fetch(url, options);
      var data = yield res.json();
      return Promise.resolve(Object.keys(data).length > 0 ? data : null);
    } catch (error) {
      _logger.default.error('CLIENT_FETCH_ERROR', url, error);

      return Promise.resolve(null);
    }
  });

  return function _fetchData(_x5) {
    return _ref12.apply(this, arguments);
  };
}();

var _apiBaseUrl = () => {
  if (typeof window === 'undefined') {
    if (!process.env.NEXTAUTH_URL) {
      _logger.default.warn('NEXTAUTH_URL', 'NEXTAUTH_URL environment variable not set');
    }

    return "".concat(__NEXTAUTH.baseUrl).concat(__NEXTAUTH.basePath);
  } else {
    return __NEXTAUTH.basePath;
  }
};

var _encodedForm = formData => {
  return Object.keys(formData).map(key => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(formData[key]);
  }).join('&');
};

var _sendMessage = message => {
  if (typeof localStorage !== 'undefined') {
    var timestamp = Math.floor(new Date().getTime() / 1000);
    localStorage.setItem('nextauth.message', JSON.stringify(_objectSpread(_objectSpread({}, message), {}, {
      clientId: __NEXTAUTH._clientId,
      timestamp
    })));
  }
};

var _default = {
  getSession,
  getCsrfToken,
  getProviders,
  useSession,
  signIn,
  signOut,
  Provider,
  setOptions,
  options: setOptions,
  session: getSession,
  providers: getProviders,
  csrfToken: getCsrfToken,
  signin: signIn,
  signout: signOut
};
exports.default = _default;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("8oxB")))

/***/ }),

/***/ "XZZD":
/***/ (function(module, exports) {

module.exports = "/_next/static/images/layout-e188961db1b584255485d91f5850f620.png";

/***/ }),

/***/ "cWnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("zLVn");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vUet");
/* harmony import */ var _SafeAnchor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("dbZe");






var defaultProps = {
  variant: 'primary',
  active: false,
  disabled: false
};
var Button = react__WEBPACK_IMPORTED_MODULE_3___default.a.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      variant = _ref.variant,
      size = _ref.size,
      active = _ref.active,
      className = _ref.className,
      block = _ref.block,
      type = _ref.type,
      as = _ref.as,
      props = Object(_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"]);

  var prefix = Object(_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__[/* useBootstrapPrefix */ "a"])(bsPrefix, 'btn');
  var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, prefix, active && 'active', variant && prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);

  if (props.href) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_SafeAnchor__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, props, {
      as: as,
      ref: ref,
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(classes, props.disabled && 'disabled')
    }));
  }

  if (ref) {
    props.ref = ref;
  }

  if (type) {
    props.type = type;
  } else if (!as) {
    props.type = 'button';
  }

  var Component = as || 'button';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(Component, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, props, {
    className: classes
  }));
});
Button.displayName = 'Button';
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ "dEHY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toBase64 = toBase64;
/**
* Isomorphic base64 that works on the server and client
*/

function toBase64(str) {
  if (false) {} else {
    return window.btoa(str);
  }
}

/***/ }),

/***/ "dQHF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("zoAU");

var _toConsumableArray = __webpack_require__("mPvQ");

var _interopRequireDefault = __webpack_require__("AroE");

exports.__esModule = true;
exports["default"] = Image;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("98FW"));

var _extends2 = _interopRequireDefault(__webpack_require__("1ccW"));

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _toBase = __webpack_require__("dEHY");

var _imageConfig = __webpack_require__("UWYU");

var _useIntersection = __webpack_require__("vNVm");

if (false) {}

var VALID_LOADING_VALUES = ['lazy', 'eager', undefined];
var loaders = new Map([['imgix', imgixLoader], ['cloudinary', cloudinaryLoader], ['akamai', akamaiLoader], ['default', defaultLoader]]);
var VALID_LAYOUT_VALUES = ['fill', 'fixed', 'intrinsic', 'responsive', undefined];

var _ref2 = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default"} || _imageConfig.imageConfigDefault,
    configDeviceSizes = _ref2.deviceSizes,
    configImageSizes = _ref2.imageSizes,
    configLoader = _ref2.loader,
    configPath = _ref2.path,
    configDomains = _ref2.domains; // sort smallest to largest


var allSizes = [].concat(_toConsumableArray(configDeviceSizes), _toConsumableArray(configImageSizes));
configDeviceSizes.sort(function (a, b) {
  return a - b;
});
allSizes.sort(function (a, b) {
  return a - b;
});

function getWidths(width, layout) {
  if (typeof width !== 'number' || layout === 'fill' || layout === 'responsive') {
    return {
      widths: configDeviceSizes,
      kind: 'w'
    };
  }

  var widths = _toConsumableArray(new Set([width, width * 2, width * 3].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));

  return {
    widths: widths,
    kind: 'x'
  };
}

function callLoader(loaderProps) {
  var load = loaders.get(configLoader);

  if (load) {
    return load((0, _extends2["default"])({
      root: configPath
    }, loaderProps));
  }

  throw new Error("Unknown \"loader\" found in \"next.config.js\". Expected: ".concat(_imageConfig.VALID_LOADERS.join(', '), ". Received: ").concat(configLoader));
}

function generateImgAttrs(_ref3) {
  var src = _ref3.src,
      unoptimized = _ref3.unoptimized,
      layout = _ref3.layout,
      width = _ref3.width,
      quality = _ref3.quality,
      sizes = _ref3.sizes;

  if (unoptimized) {
    return {
      src: src
    };
  }

  var _getWidths = getWidths(width, layout),
      widths = _getWidths.widths,
      kind = _getWidths.kind;

  var last = widths.length - 1;
  var srcSet = widths.map(function (w, i) {
    return "".concat(callLoader({
      src: src,
      quality: quality,
      width: w
    }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
  }).join(', ');

  if (!sizes && kind === 'w') {
    sizes = '100vw';
  }

  src = callLoader({
    src: src,
    quality: quality,
    width: widths[last]
  });
  return {
    src: src,
    sizes: sizes,
    srcSet: srcSet
  };
}

function getInt(x) {
  if (typeof x === 'number') {
    return x;
  }

  if (typeof x === 'string') {
    return parseInt(x, 10);
  }

  return undefined;
}

function Image(_ref) {
  var src = _ref.src,
      sizes = _ref.sizes,
      _ref$unoptimized = _ref.unoptimized,
      unoptimized = _ref$unoptimized === void 0 ? false : _ref$unoptimized,
      _ref$priority = _ref.priority,
      priority = _ref$priority === void 0 ? false : _ref$priority,
      loading = _ref.loading,
      className = _ref.className,
      quality = _ref.quality,
      width = _ref.width,
      height = _ref.height,
      objectFit = _ref.objectFit,
      objectPosition = _ref.objectPosition,
      all = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["src", "sizes", "unoptimized", "priority", "loading", "className", "quality", "width", "height", "objectFit", "objectPosition"]);
  var rest = all;
  var layout = sizes ? 'responsive' : 'intrinsic';
  var unsized = false;

  if ('unsized' in rest) {
    unsized = Boolean(rest.unsized); // Remove property so it's not spread into image:

    delete rest['unsized'];
  } else if ('layout' in rest) {
    // Override default layout if the user specified one:
    if (rest.layout) layout = rest.layout; // Remove property so it's not spread into image:

    delete rest['layout'];
  }

  if (false) {}

  var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');

  if (src && src.startsWith('data:')) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }

  var _ref4 = (0, _useIntersection.useIntersection)({
    rootMargin: '200px',
    disabled: !isLazy
  }),
      _ref5 = _slicedToArray(_ref4, 2),
      setRef = _ref5[0],
      isIntersected = _ref5[1];

  var isVisible = !isLazy || isIntersected;
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var qualityInt = getInt(quality);
  var wrapperStyle;
  var sizerStyle;
  var sizerSvg;
  var imgStyle = {
    visibility: isVisible ? 'visible' : 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    boxSizing: 'border-box',
    padding: 0,
    border: 'none',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    objectFit: objectFit,
    objectPosition: objectPosition
  };

  if (typeof widthInt !== 'undefined' && typeof heightInt !== 'undefined' && layout !== 'fill') {
    // <Image src="i.png" width="100" height="100" />
    var quotient = heightInt / widthInt;
    var paddingTop = isNaN(quotient) ? '100%' : "".concat(quotient * 100, "%");

    if (layout === 'responsive') {
      // <Image src="i.png" width="100" height="100" layout="responsive" />
      wrapperStyle = {
        display: 'block',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 0
      };
      sizerStyle = {
        display: 'block',
        boxSizing: 'border-box',
        paddingTop: paddingTop
      };
    } else if (layout === 'intrinsic') {
      // <Image src="i.png" width="100" height="100" layout="intrinsic" />
      wrapperStyle = {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 0
      };
      sizerStyle = {
        boxSizing: 'border-box',
        display: 'block',
        maxWidth: '100%'
      };
      sizerSvg = "<svg width=\"".concat(widthInt, "\" height=\"").concat(heightInt, "\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\"/>");
    } else if (layout === 'fixed') {
      // <Image src="i.png" width="100" height="100" layout="fixed" />
      wrapperStyle = {
        overflow: 'hidden',
        boxSizing: 'border-box',
        display: 'inline-block',
        position: 'relative',
        width: widthInt,
        height: heightInt
      };
    }
  } else if (typeof widthInt === 'undefined' && typeof heightInt === 'undefined' && layout === 'fill') {
    // <Image src="i.png" layout="fill" />
    wrapperStyle = {
      display: 'block',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      boxSizing: 'border-box',
      margin: 0
    };
  } else {
    // <Image src="i.png" />
    if (false) {}
  }

  var imgAttributes = {
    src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  };

  if (isVisible) {
    imgAttributes = generateImgAttrs({
      src: src,
      unoptimized: unoptimized,
      layout: layout,
      width: widthInt,
      quality: qualityInt,
      sizes: sizes
    });
  }

  if (unsized) {
    wrapperStyle = undefined;
    sizerStyle = undefined;
    imgStyle = undefined;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: wrapperStyle
  }, sizerStyle ? /*#__PURE__*/_react["default"].createElement("div", {
    style: sizerStyle
  }, sizerSvg ? /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      maxWidth: '100%',
      display: 'block'
    },
    alt: "",
    "aria-hidden": true,
    role: "presentation",
    src: "data:image/svg+xml;base64,".concat((0, _toBase.toBase64)(sizerSvg))
  }) : null) : null, /*#__PURE__*/_react["default"].createElement("img", Object.assign({}, rest, imgAttributes, {
    decoding: "async",
    className: className,
    ref: setRef,
    style: imgStyle
  })));
} //BUILT IN LOADERS


function normalizeSrc(src) {
  return src[0] === '/' ? src.slice(1) : src;
}

function imgixLoader(_ref6) {
  var root = _ref6.root,
      src = _ref6.src,
      width = _ref6.width,
      quality = _ref6.quality;
  // Demo: https://static.imgix.net/daisy.png?format=auto&fit=max&w=300
  var params = ['auto=format', 'fit=max', 'w=' + width];
  var paramsString = '';

  if (quality) {
    params.push('q=' + quality);
  }

  if (params.length) {
    paramsString = '?' + params.join('&');
  }

  return "".concat(root).concat(normalizeSrc(src)).concat(paramsString);
}

function akamaiLoader(_ref7) {
  var root = _ref7.root,
      src = _ref7.src,
      width = _ref7.width;
  return "".concat(root).concat(normalizeSrc(src), "?imwidth=").concat(width);
}

function cloudinaryLoader(_ref8) {
  var root = _ref8.root,
      src = _ref8.src,
      width = _ref8.width,
      quality = _ref8.quality;
  // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
  var params = ['f_auto', 'c_limit', 'w_' + width, 'q_' + (quality || 'auto')];
  var paramsString = params.join(',') + '/';
  return "".concat(root).concat(paramsString).concat(normalizeSrc(src));
}

function defaultLoader(_ref9) {
  var root = _ref9.root,
      src = _ref9.src,
      width = _ref9.width,
      quality = _ref9.quality;

  if (false) { var parsedSrc, missingValues; }

  return "".concat(root, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}

/***/ }),

/***/ "dbZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__("zLVn");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) return f;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      // @ts-ignore
      acc.apply(this, args); // @ts-ignore

      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ var esm_createChainedFunction = (createChainedFunction);
// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/SafeAnchor.js





function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */


var SafeAnchor = react_default.a.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'a' : _ref$as,
      disabled = _ref.disabled,
      onKeyDown = _ref.onKeyDown,
      props = Object(objectWithoutPropertiesLoose["a" /* default */])(_ref, ["as", "disabled", "onKeyDown"]);

  var handleClick = function handleClick(event) {
    var href = props.href,
        onClick = props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };

  if (isTrivialHref(props.href)) {
    props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
    // otherwise, the cursor incorrectly styled (except with role='button')

    props.href = props.href || '#';
  }

  if (disabled) {
    props.tabIndex = -1;
    props['aria-disabled'] = true;
  }

  return /*#__PURE__*/react_default.a.createElement(Component, Object(esm_extends["a" /* default */])({
    ref: ref
  }, props, {
    onClick: handleClick,
    onKeyDown: esm_createChainedFunction(handleKeyDown, onKeyDown)
  }));
});
SafeAnchor.displayName = 'SafeAnchor';
/* harmony default export */ var esm_SafeAnchor = __webpack_exports__["a"] = (SafeAnchor);

/***/ }),

/***/ "kG2m":
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),

/***/ "mPvQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__("5fIB");

var iterableToArray = __webpack_require__("rlHP");

var unsupportedIterableToArray = __webpack_require__("KckH");

var nonIterableSpread = __webpack_require__("kG2m");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),

/***/ "nGE6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("XJ4Q").default


/***/ }),

/***/ "rCWS":
/***/ (function(module, exports) {

module.exports = "/_next/static/images/dot-bg-4c3fa01d9ccc5d26f1068eabd40640d9.png";

/***/ }),

/***/ "rlHP":
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),

/***/ "v8fv":
/***/ (function(module, exports) {

module.exports = "/_next/static/images/editor-45d3aa30598752abc0f8292aac3bf0f5.png";

/***/ }),

/***/ "vFaK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = url => {
  var defaultHost = 'http://localhost:3000';
  var defaultPath = '/api/auth';

  if (!url) {
    url = "".concat(defaultHost).concat(defaultPath);
  }

  var protocol = url.match(/^http?:\/\//) ? 'http' : 'https';
  url = url.replace(/^https?:\/\//, '').replace(/\/$/, '');
  var [_host, ..._path] = url.split('/');
  var baseUrl = _host ? "".concat(protocol, "://").concat(_host) : defaultHost;
  var basePath = _path.length > 0 ? "/".concat(_path.join('/')) : defaultPath;
  return {
    baseUrl,
    basePath
  };
};

exports.default = _default;

/***/ }),

/***/ "vlRD":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("RNiq");
      }
    ]);
  

/***/ })

},[["vlRD",0,1,6,8,16,19,2,3,5,7,10,13,18,4]]]);